module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "min-height": "100%"
    }
  }, [_c('div', {
    staticClass: "Shopifylogin-container",
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bottom-content"
  }, [_c('div', {
    staticClass: "bottom-content-title"
  }, [_vm._v("\r\n                    Dropshipping Agency\r\n                  ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "router-btn",
    on: {
      "click": function($event) {
        return _vm.toCustomerLogin()
      }
    }
  }, [_vm._v("\r\n                    Get Started\r\n                  ")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "65%"
    }
  }, [_c('div', {
    staticClass: "customer-left-bg",
    style: (_vm.login_cm_bj)
  }, [_c('div', {
    staticClass: "login-opactiy"
  })])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "Register-dialog-wrapper",
    attrs: {
      "visible": _vm.showRegisterDialog,
      "modal-append-to-body": true,
      "append-to-body": true,
      "width": "30%",
      "title": "Register"
    },
    on: {
      "update:visible": function($event) {
        _vm.showRegisterDialog = $event
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shopifyLogin"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/shopifyMKDlogo.png"),
      "alt": "",
      "width": "45%"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-content"
  }, [_c('p', [_vm._v("It has never been easier to start your own")]), _vm._v(" "), _c('p', [_vm._v("dropshipping business with Shipping Revolution.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Shipping Revolution lets you find products on the")]), _vm._v(" "), _c('p', [_vm._v("world's most popular marketplaces, add them to")]), _vm._v(" "), _c('p', [_vm._v("your e-commerce store, and ship them directly to")]), _vm._v(" "), _c('p', [_vm._v("your customers.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-386c29b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/frame/ShopifyLogin.vue
// module id = 1281
// module chunks = 169